export default "__VITE_ASSET__DMKj5W3z__"